module.exports = __webpack_public_path__ + "static/media/notifications.fdc20459.png";